export const STUDENT_NETWORK_MAP_ID = 'student-network-map';
